Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.productApiContentType = "application/json";
exports.apiMethodTypeGet = "POST";
exports.productAPiEndPoint = "/qr_codes/qr_codes";
// Customizable Area End
